import React from 'react';
import { Card } from '@clockout-dev/design-elements';
import AgingBucketRow from './AgingBucketRow';
import { AGING_BUCKETS } from '../treasury.constants';
import styles from './styles/agingReceivablesCard.module.scss';

/**
 * "Aging Receivables" card. Pure presentational — iterates the
 * `AGING_BUCKETS` constant in display order and renders one
 * `AgingBucketRow` per bucket.
 */
function AgingReceivablesCard({ data }) {
    return (
        <Card className={styles.card}>
            <header className={styles.header}>
                <h3 className={styles.title}>Aging Receivables</h3>
                <p className={styles.subtitle}>Summary by time clusters</p>
            </header>

            <div className={styles.list}>
                {AGING_BUCKETS.map(({ key, label }) => {
                    const bucket = data?.[key] ?? { amount: 0, percent: 0 };
                    return (
                        <AgingBucketRow
                            key={key}
                            label={label}
                            amount={bucket.amount}
                            percent={bucket.percent}
                        />
                    );
                })}
            </div>
        </Card>
    );
}

export default AgingReceivablesCard;
